const Typography = (fontFamily) => ({
  fontFamily,
  h4: {
    fontWeight: 500,
    fontSize: '2rem',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1.2rem',
    lineHeight: 1.57,
  },
});

export default Typography;
